import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Button } from 'components/ui';

const addDownloadParam = (href: string) => {
  const url = new URL(href);
  url.searchParams.append('dl', 'true');
  url.searchParams.append('raw', 'true');
  return url.toString();
};

type DownloadButtonProps = {
  href: string;
  children?: React.ReactNode;
  useIconButton?: boolean;
};

export const DownloadButton: React.FunctionComponent<DownloadButtonProps> = ({
  href,
  children,
  useIconButton,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return useIconButton ? (
    <Button
      title={t('components.downloadImage', 'Download Image')}
      data-testid="image-controls-download"
      href={addDownloadParam(href)}
      icon={<DownloadOutlined style={{ color: theme.contrastColor }} />}
    />
  ) : (
    <Button title={t('table.download', 'Download')} data-testid="image-controls-download">
      <a href={addDownloadParam(href)}>
        <DownloadOutlined />
        {children}
      </a>
    </Button>
  );
};
